import React from 'react';
import { Activity } from 'lucide-react';
import { formatDate, formatTime } from '../../crmConstants';

export const DealActivityTab = ({ activities }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
    {activities.length === 0 ? (
      <p style={{ textAlign: 'center', color: '#9CA3AF', padding: '2rem' }}>No activity yet</p>
    ) : activities.map((activity, i) => (
      <div key={activity.id || `activity-${activity.timestamp}-${i}`} style={{
        padding: '0.75rem', borderRadius: 6, background: '#FAFBFC', border: '1px solid #E5E7EB',
        display: 'flex', gap: '0.75rem', alignItems: 'flex-start',
      }}>
        <div style={{
          width: 28, height: 28, borderRadius: '50%', background: '#E5E7EB',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          <Activity size={14} style={{ color: '#6B7280' }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '0.813rem', color: 'var(--navy)' }}>{activity.description}</div>
          <div style={{ fontSize: '0.7rem', color: '#9CA3AF', marginTop: '0.25rem' }}>
            {activity.actor_name} • {formatDate(activity.timestamp, true)} {formatTime(activity.timestamp)}
          </div>
        </div>
      </div>
    ))}
  </div>
);
